// src/App.jsx (rutas completas, con PlanEstrategico y PlanObjetivoMatriz)

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dropzone/styles.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';

import ProtectedRoute from './auth/ProtectedRoute';
import { Toast } from './components/Toast';
import AppInitializer from './components/AppInitializer';
import { createTheme, MantineProvider } from '@mantine/core';

import LoginPage from './auth/LoginPage';
import MainLayout from './layout/MainLayout';
import HomePEI from './pages/HomePei';
import SaveEvidencias from './pages/SaveEvidencias';
import EvaluationPage from './pages/EvaluationPage';
import OverviewPage from './pages/OverviewPage';
import UnitDetailPage from './pages/UnitDetailPage';
import ProcessSelectorPage from './pages/ProcessSelectorPage';
import AdminPage from './pages/AdminPage';
import EvidencesPage from './pages/EvidencesPage';

import PlanEstrategico from './components/Admin/PeiView';
import PlanObjetivoMatriz from './components/Admin/PlanObjetivoMatriz';


const theme = createTheme({
  fontFamily: 'Montserrat, serif',
  headings: { fontFamily: 'Bebas Neue, serif' },
  // colors / primaryColor si lo necesitás…
});

const App = () => {
  return (
    <MantineProvider theme={theme} withGlobalStyles withNormalizeCSS>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <AppInitializer>
              <Toast />
              <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/procesos-evaluacion" element={<ProtectedRoute element={<ProcessSelectorPage />} />}/>
                <Route path="/backoffice/*" element={<ProtectedRoute requireProcess requirePermission element={<MainLayout />} />}>
                  <Route path="home" element={< HomePEI />} />
                  <Route path="evidences" element={<EvidencesPage />}/>
                  <Route path="evidences/publish" element={<SaveEvidencias />}/>
                  <Route path="evidences/edit/:evidenceId" element={<SaveEvidencias />}/>
                  <Route path="evaluation" element={<EvaluationPage />}/>
                  <Route path="evaluation/overview" element={<OverviewPage />} />
                  <Route path="evaluation/overview/:unitId/detail" element={<UnitDetailPage />} />
                </Route>

                <Route path="/admin" element={<ProtectedRoute element={<AdminPage />} allowedRoles={['administrador']} />} />
                <Route path="/admin/pei/:id/manage" element={ <ProtectedRoute element={<PlanObjetivoMatriz />} allowedRoles={['administrador']} /> } />
              </Routes>
            </AppInitializer>
          </Router>
        </PersistGate>
      </Provider>
    </MantineProvider>
  );
};

export default App;
